<template>
  <component :is="as || 'h2'" v-if="slots?.default" :class="computedClasses">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { useCssModule } from 'vue'
const $style = useCssModule()
const slots = useSlots()

const props = defineProps<{
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  size?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7'
}>()

const fontSizes: Record<string, string> = {
  h1: 'u-type-h1',
  h2: 'u-type-h2',
  h3: 'u-type-h3',
  h4: 'u-type-h4',
  h5: 'u-type-h5',
  h6: 'u-type-h6',
  h7: 'u-type-h7',
}

const computedClasses = computed(() => {
  const size = props.size || props.as || 'h2'
  return {
    [$style.heading]: true,
    [fontSizes[size]]: size,
  }
})
</script>

<style lang="scss" module>
.heading {
  font-family: var(--roboto-condensed);
}
</style>
